import "./EmailVerification.css";

// Firebase authentication

import LoginUser from "../../controllers/auth/Login";
import BrandLogoTop from "../../components/BrandLogo/BrandLogoTop";
import BrandLogoEnd from "../../components/BrandLogo/BrandLogoEnd";

import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

// Form Validate imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import GetEmailVerificationCode from "../../controllers/auth/GetEmailVerificationCode";
import SetEmailVerified from "../../controllers/auth/SetEmailVerified";
import {
  AuthErrorMessages,
  ToastSuccessMessages,
} from "../../controllers/auth/AuthErrorMessages";
import { getAuth } from "firebase/auth";

import Logout from "../../controllers/auth/Logout";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import GetSingleUser from "../../controllers/users/GetSingleUser";
import OtpField from "react-otp-field";
import { ToastContainer } from "react-toastify";

import verifyEmailCoverPhoto from "../../assets/login/verifyEmail.svg";
// Form Validate imports End
import { getFunctions, httpsCallable } from "firebase/functions";

// Form Validate schema Start
const schema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().min(6).max(15).required(),
});
// Form Validate schema End

const EmailVerification = () => {
  // Form Validate const Start
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  // Form Validate const End
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Vcode, setVcode] = useState("");
  const [userData, setUserData] = useState({});
  // const [email, setEmail] = useState("");
  // const [uid, setUid] = useState("");
  // const [userName, setUserName] = useState("");
  // const [businessName, setBusinessName] = useState("");
  const [Error, setError] = useState(false);
  const [FormDisabled, setFormDisabled] = useState(false);

  const [IsUserLoggedIn, setIsUserLoggedIn] = useState(false);

  const [sendEmailAgain, setSendEmailAgain] = useState(false);

  const functions = getFunctions();
  useEffect(() => {
    getAuth().onAuthStateChanged(async (result) => {
      if (result == null) {
        setIsUserLoggedIn(false);
        // window.location.pathname = "/";
      } else {
        setIsUserLoggedIn(true);
        const user = await GetSingleUser(result.uid);
        setUserData({ ...userData, ...user });
        // setEmail(result.email);
        // setUid(result.uid);
        // setUserName(user.name);
        // setBusinessName(user.businessName);
      }
    });
  }, []);

  const ProcessCodeVerification = async (e) => {
    setFormDisabled(true);
    const user = await LoginUser(e.email, e.password, e.RememberMe);
    if (user !== false) {
      dispatch({
        type: "ADD_NEW_USER",
        payload: user,
      });

      // navigate("/verify/email/success");
      setFormDisabled(true);
    } else if (user === false) {
      setFormDisabled(false);
    }
  };

  // const [Email, setEmail] = useState("");

  const [ShowResetModal, setShowResetModal] = useState(false);
  const handleCloseResetModal = () => setShowResetModal(false);
  const handleShowResetModal = () => setShowResetModal(true);

  const [Loading, setLoading] = useState(false);
  const handleStartLoading = () => setLoading(true);
  const handleStopLoading = () => setLoading(false);

  const verifyEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const emailCodeGet = (await GetEmailVerificationCode()) * 1;
      if (emailCodeGet == Vcode * 1) {
        await SetEmailVerified();
        setLoading(false);
        navigate("/verify/email/success");
      } else {
        AuthErrorMessages("auth/invalid-code");
        setLoading(false);
        setError(true);
      }
    } catch (ex) {
      console.log("ex verifyEmail", ex);
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="register-page-container">
        <div className="register-page-content">
          <div className="auth-content-container">
            <div
              className="register-cover-photo
              verify-email-cover-photo-container
            "
            >
              <img
                src={verifyEmailCoverPhoto}
                alt="img"
                className="verify-email-cover-photo"
              />
            </div>
            <div className="register-auth-form register-auth-form-verify-email">
              <div className="register-logo-top">
                <BrandLogoTop />
              </div>
              <div className="register-top-svg">
                <img
                  src={verifyEmailCoverPhoto}
                  alt="img"
                  className="verify-email-cover-photo"
                />
              </div>
              <div className="register-form-container">
                <p className="form-description-text">
                  We have sent a verification code on{" "}
                  <span className="verify-email"> {userData?.email}</span>.
                  Please enter the code to verify your email. or{" "}
                  <span
                    className="verify-email-go-back"
                    onClick={async () => {
                      try {
                        const deleteUser = httpsCallable(
                          functions,
                          "deleteUser"
                        );

                        const bid = getLocalStorageItem("bid");

                        await deleteUser({ uid: userData.id, bid: bid }).then(
                          () => {
                            navigate("/register");
                            Logout();
                          }
                        );
                      } catch (err) {
                        console.log(err);
                      }
                    }}
                  >
                    Go Back
                  </span>{" "}
                  to change email.
                </p>
              </div>

              <div>
                <div className="resend-code-container">
                  <span className=" form-field-label mt-2">
                    Verification Code
                  </span>
                </div>

                <form onSubmit={verifyEmail}>
                  <div className="mail-otp-container-web-screen">
                    <OtpField
                      value={Vcode}
                      onChange={(val) => {
                        setVcode(val);
                      }}
                      autoFocus
                      numInputs={6}
                      isTypeNumber={true}
                      onChangeRegex={/^([0-9]{0,})$/}
                      separator={<span> </span>}
                      inputProps={{
                        className: "otp-field__input",
                        disabled: false,
                      }}
                    />
                  </div>

                  {Error && <p className="text-danger">Invalid code</p>}

                  <div className="text-center">
                    <button
                      type="submit"
                      className="form-submit-button py-2"
                      disabled={Loading || Vcode.length < 6}
                    >
                      {Loading ? (
                        <div
                          className="spinner-border  spinner-border-sm"
                          role="status"
                        ></div>
                      ) : (
                        "Verify"
                      )}
                    </button>
                  </div>
                </form>
                <div>
                  <p className="form-description-text mt-2 text-center">
                    Didn't receive an email? check your spam folder Or
                  </p>
                  {/* resend email  */}
                  {sendEmailAgain ? (
                    <div className="spinner-container">
                      <div
                        className="spinner-border 
                       spinner-border-sm
               "
                        role="status"
                      >
                        <span className="sr-only"></span>
                      </div>
                    </div>
                  ) : (
                    <div
                      onClick={async () => {
                        setSendEmailAgain(true);
                        if (!getAuth().currentUser) {
                          AuthErrorMessages("client/unable-to-send-email");
                          setSendEmailAgain(false);
                          return;
                        }
                        const ResendEmailVerificationCode = httpsCallable(
                          functions,
                          "ResendEmailVerificationCode"
                        );

                        let email = userData.email;
                        let uid = getAuth().currentUser.uid;
                        let data = { email, uid };
                        let resp = await ResendEmailVerificationCode(data);
                        if (resp) {
                          setSendEmailAgain(false);
                          ToastSuccessMessages("email/resend-email-successful");
                        } else {
                          AuthErrorMessages("client/unable-to-send-email");
                        }
                      }}
                      className="resend-email-label mt-2"
                    >
                      <span className="re-send-code ">Resend Email</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="logo-end">
            <BrandLogoEnd />
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailVerification;
